import { useMutation } from "@apollo/client/react";import React, { useCallback, useEffect, useState } from "react";
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import { CustomButton } from "../../../../../components/customButton/CustomButton";
import { RenderInputByTypeMobile } from '../../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { obtenerDataImagen } from '../../../../../actions/ImagenAction';
import GrillaVacia from '../../../../../assets/images/grilla-vacia-resumen-ingreso.svg';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { adaptEstudiosArray } from '../../../../../adapters/resumenIngreso/estudiosAdjuntosAdapter';
import { DELETE_DOCUMENTO_ESTUDIO_RI } from "../../../../../data/graphQL/mutations/ResumenIngreso/deleteDocumentoEstudioRI";

import { generateGUID } from '../../../../../helpers/guidHelper';
import { Box } from "@mui/material";
import toast from 'react-hot-toast';

export const MultipleFileInput = ({
  handleChange,
  prevEstudiosAdjuntos,
  setChildrenAction,
  idDatosGeneralesRI,
  readOnly = false
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const estudiosAdjuntosInitial = prevEstudiosAdjuntos?.length > 0 ?
  prevEstudiosAdjuntos?.map((estudio) => ({
    file: { ...estudio },
    nombre: estudio.titulo,
    key: generateGUID()
  })) :
  [];
  const [estudiosAdjuntos, setEstudiosAdjuntos] = useState([...estudiosAdjuntosInitial]);
  const [estudioAux, setEstudioAux] = useState({});
  const [deleteDocumentoEstudio] = useMutation(DELETE_DOCUMENTO_ESTUDIO_RI);

  useEffect(() => {
    if (!estudiosAdjuntos.length) return setChildrenAction(null);

    setChildrenAction(() =>
    <CustomButton
      onClick={handleOpenModal}
      disabled={readOnly}
      size='small'
      variant='outlined'>
      
                Agregar
            </CustomButton>
    );

  }, [estudiosAdjuntos, readOnly]);

  useEffect(() => {
    handleChange('estudioAdjunto', adaptEstudiosArray(estudiosAdjuntos));
  }, [estudiosAdjuntos]);

  const columns = generateColumnsDefaultConfiguration([
  {
    field: 'action',
    headerName: '',
    flex: 0.1,
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return (
        <DeleteOutlineIcon className='edit-icon' onClick={() => deleteEstudio(row)} />);

    }
  },
  {
    headerName: 'Nombre del estudio',
    field: 'nombre',
    flex: 0.6
  },
  {
    field: 'action2',
    headerName: 'Adjunto',
    flex: 0.3,
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return (
        <AttachFileOutlinedIcon className='edit-icon' onClick={() => editEstudio(row)} />);

    }
  }]
  );

  const handleChangeImage = useCallback(async (nuevoEstudio) => {
    try {
      var image = await obtenerDataImagen(nuevoEstudio);

      const updateFile = {
        contentType: image?.tipo,
        archivo: image?.data,
        extension: image?.extension,
        titulo: image?.nombre
      };

      const updatedEstudio = Boolean(estudioAux?.key) ?
      { ...estudioAux, file: updateFile } :
      { ...estudioAux, key: generateGUID(), file: updateFile };

      setEstudioAux(structuredClone(updatedEstudio));
    } catch (error) {
      console.log(error);
    }
  }, [estudioAux, setEstudioAux]);

  const handleNameEstudio = (value) => {
    setEstudioAux((prevEstudio) => {
      return { ...prevEstudio, nombre: value };
    });
  };

  const handleClose = () => {
    setEstudioAux({});
    setOpenModal(false);
  };

  const handleAccept = () => {
    if (!estudioAux?.file) {
      toast.error('Debe adjuntar un archivo.');
      return;
    }

    if (Boolean(estudioAux?.key) && estudiosAdjuntos.some((e) => e.key === estudioAux?.key)) {
      setEstudiosAdjuntos((prevEstudios) =>
      prevEstudios.map((estudio) => {
        if (estudio.key === estudioAux.key) {
          return { ...estudioAux };
        }
        return estudio;
      })
      );
    } else {
      setEstudiosAdjuntos((prevEstudios) => [...prevEstudios, estudioAux]);
    }
    handleClose();
  };

  const handleOpenModal = () => setOpenModal(true);

  const deleteEstudio = useCallback(async (estudio) => {
    try {
      await deleteDocumentoEstudio({
        variables: {
          input: {
            titulo: estudio?.file?.titulo,
            idDatosGeneralesRI: idDatosGeneralesRI
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
    setEstudiosAdjuntos((prevEstudios) => [...prevEstudios.filter((element) => element.key !== estudio.key)]);
  }, [setEstudiosAdjuntos]);

  const onDeleteImage = () => {
    if (estudioAux?.key)
    setEstudioAux({ nombre: estudioAux.nombre ?? '', key: estudioAux.key });else

    setEstudioAux({ nombre: estudioAux.nombre ?? '' });
  };

  const editEstudio = useCallback((estudio) => {
    setEstudioAux({ ...estudio });
    setIsEditing(true);
  }, [setEstudioAux]);

  useEffect(() => {
    if (isEditing && estudioAux?.key) {
      setOpenModal(true);
      setIsEditing(false);
    }
  }, [isEditing, estudioAux]);

  return (
    <>
            {!estudiosAdjuntos?.length && <div className='resumen-ingreso-grilla-vacia'>
                <div className='svg-clientes-grilla-vacia'>
                    <img src={GrillaVacia} width='100%'></img>
                </div>
                <label>No se ha agregado ningún estudio</label>
                <CustomButton
          sx={{ mt: 2 }}
          onClick={handleOpenModal}
          size='small'
          disabled={readOnly}>
          
                    Agregar
                </CustomButton>
            </div>}
            {!!estudiosAdjuntos.length &&
      <Box sx={{ width: '100%' }}>
                    <DataGridGenerico
          columns={columns}
          rows={estudiosAdjuntos}
          toolbar={false}
          hideFooter />
        
                </Box>
      }
            <CustomDialog
        maxWidth='md'
        fullWidth
        onCancel={handleClose}
        open={openModal}
        cancelText='Cerrar'
        onAccept={handleAccept}
        acceptDisabled={!estudioAux.nombre}
        acceptText='Aceptar'
        title='Estudios Adjuntos'>
        
                <RenderInputByTypeMobile
          grided
          handleChange={(_, value) => handleNameEstudio(value)}
          input={{
            name: 'nombreEstudio',
            displayName: 'Nombre del estudio',
            type: 'string',
            required: true
          }}
          value={estudioAux?.nombre || ''} />
        
                <RenderInputByTypeMobile
          grided
          handleChange={(_, value) => handleChangeImage(value)}
          input={{
            name: 'estudioAdjunto',
            displayName: 'Adjuntar estudio',
            type: 'file',
            validExtensions: ['PDF', 'PNG', 'JPG', 'HEIC', 'JPEG', 'JFIF'],
            required: true,
            disabled: false,
            maxFileSize: 8,
            onDeleteImage: () => onDeleteImage()
          }}
          value={estudioAux.file || null} />
        
            </CustomDialog>
        </>);

};